import { HeatmapContact } from './useHeatmapData';
import { getContactDisplayName } from '@/util/contactUtils';

/**
 * Creates HTML content for InfoWindow from contact data
 */
export const createInfoWindowContent = (contact: HeatmapContact): string => {
  const fullName = getContactDisplayName(contact);
  const address = contact.address?.name || '';
  const activitiesCount = contact.activitiesCount ?? contact.activities?.length ?? 0;

  let activitiesHtml = '';
  if (contact.activities && contact.activities.length > 0) {
    activitiesHtml = '<div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #e0e0e0;">';
    activitiesHtml +=
      '<div style="font-weight: 600; margin-bottom: 8px; font-family: \'Noto Sans Hebrew\', Arial, sans-serif;">פעילויות:</div>';

    contact.activities.forEach((activity, index) => {
      activitiesHtml +=
        '<div style="margin-bottom: 12px; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">';

      if (activity.operationName) {
        activitiesHtml += `<div style="font-weight: 500; margin-bottom: 4px; font-family: 'Noto Sans Hebrew', Arial, sans-serif;">${activity.operationName}</div>`;
      }

      if (activity.category) {
        activitiesHtml += `<div style="font-size: 12px; color: #666; margin-bottom: 4px; font-family: 'Noto Sans Hebrew', Arial, sans-serif;">קטגוריה: ${activity.category}</div>`;
      }

      if (activity.description) {
        activitiesHtml += `<div style="font-size: 12px; color: #666; margin-bottom: 4px; font-family: 'Noto Sans Hebrew', Arial, sans-serif;">${activity.description}</div>`;
      }

      if (activity.createdAt) {
        const date = new Date(activity.createdAt).toLocaleDateString('he-IL');
        activitiesHtml += `<div style="font-size: 12px; color: #666; font-family: 'Noto Sans Hebrew', Arial, sans-serif;">${date}</div>`;
      }

      activitiesHtml += '</div>';
    });

    activitiesHtml += '</div>';
  }

  return `
    <div style="padding: 8px; min-width: 250px; max-width: 350px; font-family: 'Noto Sans Hebrew', Arial, sans-serif; direction: rtl;">
      <div style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">${fullName}</div>
      
      ${
        address
          ? `
        <div style="font-size: 14px; color: #666; margin-bottom: 8px;">${address}</div>
        <div style="margin: 8px 0; border-top: 1px solid #e0e0e0;"></div>
      `
          : ''
      }
      
      <div style="font-size: 14px; font-weight: 500; margin-bottom: 8px;">מספר פעילויות: ${activitiesCount}</div>
      
      ${activitiesHtml}
    </div>
  `;
};
